import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Subscription } from "rxjs";
import { DatesService } from "src/app/services/dates/dates.service";
import { FormConstantes } from '../../../constantes/global/form-constantes';
import { ValeurListeFixeModel } from "../../../models/listes-fixes/valeur-liste-fixe.model";
import { EtatTache, Tache } from '../../../models/taches/gestion-taches.model';
import { ToastErrorModel } from '../../../models/toasts/toast-error.model';
import { GestionProjetService } from '../../../services/gestion-projet/gestion-projet.service';
import { ListeFixeCategoriesTacheService } from "../../../services/gestion-projet/liste-fixe-categories-tache.service";
import { NotificationToastService } from '../../../services/notifications/notification-toast.service';
import { ValidatorsBuilderService } from "../../../validators/validators-with-message/eparcours-validators/validators-builder.service";

@Component({
  selector: 'app-edit-tache-form',
  templateUrl: './edit-tache-form.component.html',
  styleUrls: ['./edit-tache-form.component.scss'],
})
export class EditTacheFormComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('inputFocus') inputFocus: ElementRef;
  etats: EtatTache[] =  [EtatTache.AFaire, EtatTache.EnCours, EtatTache.Termine];

  @Output() modifier: EventEmitter<void> = new EventEmitter<void>();
  @Output() cancel = new EventEmitter();
  @Input() set tache(value: Tache) {
    this.originalValue = value;
    this.tacheForm.reset(value);
    if(value.date === undefined){
      this.tacheForm.get('date').patchValue(new Date());
    }
  }

  public tacheForm: UntypedFormGroup;
  public switchHeuresControl: boolean;
  private subs: Subscription[] = [];
  private originalValue: Tache;
  public listeFixeCategoriesTache: ValeurListeFixeModel[];

  libellesEtats = {
    [EtatTache.AFaire]: 'À faire',
    [EtatTache.EnCours]: 'En cours',
    [EtatTache.Termine]: 'Terminé'
  };

  constructor(
    private formBuilder: UntypedFormBuilder,
    private validatorsBuilder: ValidatorsBuilderService,
    private notificationService: NotificationToastService,
    private listeFixeCategoriesTacheService: ListeFixeCategoriesTacheService,
    private gestionProjetService: GestionProjetService,
    private dateService: DatesService)
  {
    this.buildForm();
    this.manageSubscribe();
  }

  ngOnInit() {}

  ngOnDestroy(): void {
    this.subs.forEach(it => it.unsubscribe());
    this.subs = [];
  }

  ngAfterViewInit(): void {
    this.inputFocus.nativeElement.focus();
  }

  get showDetailHeures(): boolean {
    return this.hasDate && this.switchHeuresControl || this.getControl('heureDebut').value;
  }

  public getControl(controlName: string){
    return this.tacheForm.get(controlName);
  }

  public isChecked(event){
    this.switchHeuresControl = event.target.checked;
    if(event.target.checked){
      this.getControl('heureDebut').addValidators(this.validatorsBuilder.required());
      this.getControl('heureFin').addValidators(this.validatorsBuilder.required());
      this.tacheForm.get('heureDebut').patchValue(this.dateService.hourMinutesZeroStart());
      this.tacheForm.get('heureFin').patchValue(this.dateService.hourMinutesZeroEnd());
    }else{
      this.getControl('heureDebut').clearValidators();
      this.getControl('heureFin').clearValidators();
      this.getControl('heureDebut').setValue(null);
      this.getControl('heureFin').setValue(null);
    }
    this.tacheForm.updateValueAndValidity();
  }

  private manageSubscribe() {
    this.subs.push(
      this.listeFixeCategoriesTacheService.getValeurs().subscribe(liste => (this.chargerListeFixe(liste)))
    );

    this.subs.push(
      this.getControl('date').valueChanges.subscribe(v => {
        if (v == null) {
          this.switchHeuresControl = false;
        }
      })
    );

    // this.subs.push(
    //   this.switchHeuresControl.valueChanges.subscribe(v => {
    //     if (v == false) {
    //       this.heureDebutControl.clearValidators();
    //       this.heureFinControl.clearValidators();
    //       this.heureDebutControl.setValue(null);
    //       this.heureFinControl.setValue(null);
    //     }
    //     else {
    //       this.heureDebutControl.setValidators(Validators.required);
    //       this.heureFinControl.setValidators(Validators.required);
    //     }
    //     this.tacheForm.updateValueAndValidity();
    //   })
    // );

    // this.subs.push(
    //   merge(this.heureDebutControl.valueChanges.pipe(
    //       tap(v => {
    //         if (v === '') {
    //           this.heureDebutControl.setValue(null, {emitEvent: false});
    //         }
    //     })
    //   ), this.heureFinControl.valueChanges.pipe(
    //     tap(v => {
    //       if (v === '') {
    //         this.heureFinControl.setValue(null, {emitEvent: false});
    //       }
    //     }))
    //   ).subscribe(v => {
    //     if (v != null) {
    //       this.switchHeuresControl.setValue(true);
    //     }
    //   })
    // );
  }

  private setDefaultHourTo8(date: Date) {
    if (date != null) {
      const result = new Date(date);
      if (result.getHours() == 0) {
        result.setHours(8);
      }
      return result;
    }
    return date;
  }

  private correctDateRappel() {
    this.getControl('date').setValue(this.setDefaultHourTo8(this.getControl('date').value));
  }

  enregistrer() {
    if (this.tacheForm.valid) {
      this.correctDateRappel();
      this.gestionProjetService.upsertTache(this.tacheForm.value).subscribe(() => this.modifier.emit(this.tacheForm.value));
    }
    else {
      this.notificationService.push(new ToastErrorModel(FormConstantes.required));
    }
  }

  private buildForm() {
    this.tacheForm = this.formBuilder.group({
      id: [],
      titre: [null, [this.validatorsBuilder.required(),this.validatorsBuilder.format(/[^ ]+/, 'Le titre ne doit pas être vide')]],
      description: [null],
      date: [null],
      etat: [EtatTache.AFaire],
      heureDebut: [null],
      heureFin: [null],
      dateTerminaison: [null],
      idCategorie: [null],
      liens: []
    });
  }

  annuler() {
    this.cancel.emit();
  }

  chargerListeFixe(liste: Array<ValeurListeFixeModel>) {
    this.listeFixeCategoriesTache = [{id: null, libelle: ''}];

    let value: ValeurListeFixeModel;
    for (value of liste) {
      this.listeFixeCategoriesTache.push(value);
    }
  }

  getValidationButtonCaption() {
    if (this.getControl('id').value == null) {
      return 'Ajouter';
    } else {
      return 'Modifier';
    }
  }

  hasDate() {
    return this.getControl('date').value != null;
  }

  getLibelleEtat(etat: EtatTache) {
    return this.libellesEtats[etat];
  }
}
